import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Builder4ra56zvvku0a as Builder } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance14tgug8r8maei as Companion_getInstance } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ExecutionContext.mjs';
import { plus310ted5e4i90h as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { withContext3b6r4oljqqy1b as withContext } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Builder3d75eph7uovs3 as Builder_0 } from './network/http/HttpNetworkTransport.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Builder1suvx83rlbrz1 as Builder_1 } from './network/websocket/WebSocketNetworkTransport.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDurationba1nlt78o6vu as toDuration,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { Builder3moivcm5iuump as Builder_2 } from './network/ws/WebSocketNetworkTransport.mjs';
import { get_defaultDispatcher3rblue9uzsji2 as get_defaultDispatcher } from './internal/dispatchers.js.mjs';
import {
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  cancel36mj9lv3a0whl as cancel,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { ConcurrencyInfo3mmnli95yq2g0 as ConcurrencyInfo } from './ConcurrencyInfo.mjs';
import { NetworkInterceptor22fszyorwx7pt as NetworkInterceptor } from './interceptor/NetworkInterceptor.mjs';
import { RetryOnErrorInterceptor2wqvvqzzzk2ot as RetryOnErrorInterceptor } from './interceptor/RetryOnErrorInterceptor.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { ApolloCallpwdxdy18rzuy as ApolloCall } from './ApolloCall.mjs';
import { channelFlow1or0c85tk04v1 as channelFlow } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { buffer2o7vhreze5nfc as buffer } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Context.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { DefaultInterceptorChain10weji0clzo5q as DefaultInterceptorChain } from './interceptor/ApolloInterceptor.mjs';
import { onEach13yrgg7fxnyl6 as onEach } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Transform.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_allInterceptors__eyuk02($this) {
  var tmp0 = $this.j62_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('allInterceptors', 1, tmp, ApolloClient$_get_allInterceptors_$ref_sf7sgp(), null);
  return tmp0.n3();
}
var BuilderClass;
function Builder_3() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.m62_1 = new (Builder())();
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.n62_1 = ArrayList().p2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.o62_1 = ArrayList().p2();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_1.p62_1 = ArrayList().p2();
        var tmp_2 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_2.q62_1 = ArrayList().p2();
        var tmp_3 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_3.r62_1 = ArrayList().p2();
        this.s62_1 = this.r62_1;
        this.t62_1 = Companion_getInstance().y42_1;
        this.u62_1 = null;
        this.v62_1 = null;
        this.w62_1 = null;
        this.x62_1 = null;
        this.y62_1 = null;
        this.z62_1 = null;
        this.a63_1 = null;
        this.b63_1 = null;
        this.c63_1 = null;
        this.d63_1 = null;
        this.e63_1 = null;
        this.f63_1 = null;
        this.g63_1 = null;
        this.h63_1 = null;
        this.i63_1 = null;
        this.j63_1 = null;
        this.k63_1 = null;
        this.l63_1 = null;
        this.m63_1 = null;
        this.n63_1 = null;
        this.o63_1 = null;
        this.p63_1 = null;
        this.q63_1 = null;
        this.r63_1 = null;
        this.s63_1 = null;
        this.t63_1 = true;
      }
      u63() {
        return this.m62_1.e3a();
      }
      v63() {
        return plus(plus(plus(this.n62_1, this.o62_1), this.p62_1), this.q62_1);
      }
      n43(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.t63_1 = sendEnhancedClientAwareness;
        return this;
      }
      m43(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.q63_1 = failFastIfOffline;
        return this;
      }
      w63(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.o63_1 = retryOnError;
        return this;
      }
      x63(retryOnErrorInterceptor) {
        // Inline function 'kotlin.apply' call
        this.p63_1 = retryOnErrorInterceptor;
        return this;
      }
      y63(cacheInterceptor) {
        // Inline function 'kotlin.apply' call
        this.r63_1 = cacheInterceptor;
        return this;
      }
      z63(autoPersistedQueryInterceptor) {
        // Inline function 'kotlin.apply' call
        this.s63_1 = autoPersistedQueryInterceptor;
        return this;
      }
      c43(url) {
        // Inline function 'kotlin.apply' call
        this.u62_1 = url;
        return this;
      }
      d43(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.v62_1 = httpMethod;
        return this;
      }
      e43(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.w62_1 = httpHeaders;
        return this;
      }
      g43(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.x62_1 = sendApqExtensions;
        return this;
      }
      h43(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.y62_1 = sendDocument;
        return this;
      }
      i43(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.z62_1 = enableAutoPersistedQueries;
        return this;
      }
      j43(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.a63_1 = canBeBatched;
        return this;
      }
      k43(ignoreUnknownKeys) {
        // Inline function 'kotlin.apply' call
        this.b63_1 = ignoreUnknownKeys;
        return this;
      }
      a64(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.f63_1 = serverUrl;
        return this;
      }
      b64(httpServerUrl) {
        // Inline function 'kotlin.apply' call
        this.f63_1 = httpServerUrl;
        return this;
      }
      c64(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.g63_1 = httpEngine;
        return this;
      }
      d64(httpExposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.k63_1 = httpExposeErrorBody;
        return this;
      }
      e64(httpInterceptors) {
        // Inline function 'kotlin.apply' call
        this.r62_1.y4();
        this.r62_1.u2(httpInterceptors);
        return this;
      }
      f64(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.h63_1 = webSocketServerUrl;
        return this;
      }
      g64(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.n63_1 = webSocketServerUrl;
        return this;
      }
      h64(webSocketIdleTimeoutMillis) {
        // Inline function 'kotlin.apply' call
        this.i63_1 = webSocketIdleTimeoutMillis;
        return this;
      }
      i64(wsProtocolFactory) {
        // Inline function 'kotlin.apply' call
        this.j63_1 = wsProtocolFactory;
        return this;
      }
      j64(webSocketEngine) {
        // Inline function 'kotlin.apply' call
        this.l63_1 = webSocketEngine;
        return this;
      }
      k64(webSocketReopenWhen) {
        // Inline function 'kotlin.apply' call
        this.m63_1 = webSocketReopenWhen;
        return this;
      }
      l64(networkTransport) {
        // Inline function 'kotlin.apply' call
        this.c63_1 = networkTransport;
        return this;
      }
      m64(subscriptionNetworkTransport) {
        // Inline function 'kotlin.apply' call
        this.d63_1 = subscriptionNetworkTransport;
        return this;
      }
      n64(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this.m62_1.y4();
        this.m62_1.i48(customScalarAdapters);
        return this;
      }
      o64(dispatcher) {
        // Inline function 'kotlin.apply' call
        this.e63_1 = dispatcher;
        return this;
      }
      a43(executionContext) {
        // Inline function 'kotlin.apply' call
        this.t62_1 = executionContext;
        return this;
      }
      e3a() {
        return new (ApolloClient())(this.z3a());
      }
      z3a() {
        // Inline function 'kotlin.also' call
        var this_0 = (new (Builder_3())()).n64(this.m62_1.e3a());
        this_0.n62_1.u2(this.n62_1);
        this_0.o62_1.u2(this.o62_1);
        this_0.p62_1.u2(this.p62_1);
        this_0.q62_1.u2(this.q62_1);
        return this_0.o64(this.e63_1).a43(this.t62_1).c43(this.u62_1).d43(this.v62_1).e43(this.w62_1).b64(this.f63_1).c64(this.g63_1).d64(this.k63_1).e64(this.s62_1).g43(this.x62_1).h43(this.y62_1).i43(this.z62_1).j43(this.a63_1).k43(this.b63_1).l64(this.c63_1).m64(this.d63_1).f64(this.h63_1).g64(this.n63_1).j64(this.l63_1).k64(this.m63_1).h64(this.i63_1).i64(this.j63_1).w63(this.o63_1).x63(this.p63_1).y63(this.r63_1).z63(this.s63_1).m43(this.q63_1).n43(this.t63_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_3);
    BuilderClass = $;
  }
  return BuilderClass;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $_0 {
      constructor(function_0) {
        this.p64_1 = function_0;
      }
      *q1e(value, $completion) {
        return yield* $(this.p64_1(value, $completion), $completion);
      }
      j5() {
        return this.p64_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.j5(), other.j5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.j5());
      }
    }
    initMetadataForClass($_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $_0;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
function ApolloClient$_get_allInterceptors_$ref_sf7sgp() {
  return constructCallableReference((p0) => _get_allInterceptors__eyuk02(p0), 1, 0, 227);
}
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda($this_channelFlow) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* $this_channelFlow.w1b(it, $completion);
    return Unit_instance;
  }), 1);
}
function ApolloClient$executeAsFlowInternal$slambda$slambda(this$0, $apolloRequest, $throwing, $this_channelFlow) {
  return constructCallableReference(($this$withContext, $completion) => orPromise($completion, function *($completion) {
    var tmp = this$0.q64($apolloRequest, $throwing);
    var tmp_0 = ApolloClient$executeAsFlowInternal$slambda$slambda$slambda($this_channelFlow);
    yield* tmp.t1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp_0), $completion);
    return Unit_instance;
  }), 1);
}
function ApolloClient$executeAsFlowInternal$slambda(this$0, $apolloRequest, $throwing) {
  return constructCallableReference(($this$channelFlow, $completion) => orPromise($completion, function *($completion) {
    yield* withContext(this$0.o61_1.r64_1, ApolloClient$executeAsFlowInternal$slambda$slambda(this$0, $apolloRequest, $throwing, $this$channelFlow), $completion);
    return Unit_instance;
  }), 1);
}
function ApolloClient$apolloResponses$slambda() {
  return constructCallableReference((response, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    if (!(response.c45_1 == null)) {
      throw ensureNotNull(response.c45_1);
    }
    return Unit_instance;
  }), 1);
}
var ApolloClientClass;
function ApolloClient() {
  if (ApolloClientClass === VOID) {
    class $ {
      constructor(builder) {
        this.n61_1 = builder;
        this.r61_1 = this.n61_1.v63();
        this.s61_1 = this.n61_1.u63();
        this.t61_1 = this.n61_1.r63_1;
        this.u61_1 = this.n61_1.s63_1;
        this.v61_1 = this.n61_1.o63_1;
        this.w61_1 = this.n61_1.p63_1;
        this.x61_1 = this.n61_1.q63_1;
        this.y61_1 = this.n61_1.t63_1;
        this.z61_1 = this.n61_1.t62_1;
        this.a62_1 = this.n61_1.u62_1;
        this.b62_1 = this.n61_1.v62_1;
        this.c62_1 = this.n61_1.w62_1;
        this.d62_1 = this.n61_1.x62_1;
        this.e62_1 = this.n61_1.y62_1;
        this.f62_1 = this.n61_1.z62_1;
        this.g62_1 = this.n61_1.a63_1;
        this.h62_1 = this.n61_1.b63_1;
        var tmp = this;
        var tmp_0;
        if (!(this.n61_1.c63_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.n61_1.f63_1 == null)) {
            var message = "Apollo: 'httpServerUrl' has no effect if 'networkTransport' is set. Configure httpServerUrl on the networkTransport directly.";
            throw IllegalStateException().o(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!(this.n61_1.g63_1 == null)) {
            var message_0 = "Apollo: 'httpEngine' or 'okHttpClient' has no effect if 'networkTransport' is set. Configure httpEngine on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_0));
          }
          // Inline function 'kotlin.check' call
          if (!this.n61_1.s62_1.n1()) {
            var message_1 = "Apollo: 'addHttpInterceptor' has no effect if 'networkTransport' is set. Configure the interceptors on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_1));
          }
          // Inline function 'kotlin.check' call
          if (!(this.n61_1.k63_1 == null)) {
            var message_2 = "Apollo: 'httpExposeErrorBody' has no effect if 'networkTransport' is set. Configure httpExposeErrorBody on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_2));
          }
          tmp_0 = ensureNotNull(this.n61_1.c63_1);
        } else {
          // Inline function 'kotlin.apply' call
          var this_0 = (new (Builder_0())()).a65(this.n61_1.f63_1);
          if (!(this.n61_1.g63_1 == null)) {
            this_0.b65(ensureNotNull(this.n61_1.g63_1));
          }
          if (!(this.n61_1.k63_1 == null)) {
            this_0.c65(ensureNotNull(this.n61_1.k63_1));
          }
          tmp_0 = this_0.d65(this.n61_1.s62_1).e3a();
        }
        tmp.p61_1 = tmp_0;
        var tmp_1 = this;
        var tmp_2;
        if (!(this.n61_1.d63_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.n61_1.h63_1 == null)) {
            var message_3 = "Apollo: 'webSocketServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_3));
          }
          // Inline function 'kotlin.check' call
          if (!(this.n61_1.l63_1 == null)) {
            var message_4 = "Apollo: 'webSocketEngine' or 'okHttpClient' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketEngine on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_4));
          }
          // Inline function 'kotlin.check' call
          if (!(this.n61_1.i63_1 == null)) {
            var message_5 = "Apollo: 'webSocketIdleTimeoutMillis' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketIdleTimeoutMillis on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_5));
          }
          // Inline function 'kotlin.check' call
          if (!(this.n61_1.j63_1 == null)) {
            var message_6 = "Apollo: 'wsProtocolFactory' has no effect if 'subscriptionNetworkTransport' is set. Configure wsProtocolFactory on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_6));
          }
          // Inline function 'kotlin.check' call
          if (!(this.n61_1.m63_1 == null)) {
            var message_7 = "Apollo: 'webSocketReopenWhen' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenWhen on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_7));
          }
          // Inline function 'kotlin.check' call
          if (!(this.n61_1.n63_1 == null)) {
            var message_8 = "Apollo: 'webSocketReopenServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_8));
          }
          tmp_2 = ensureNotNull(this.n61_1.d63_1);
        } else {
          var tmp0_elvis_lhs = this.n61_1.h63_1;
          var url = tmp0_elvis_lhs == null ? this.n61_1.f63_1 : tmp0_elvis_lhs;
          var tmp_3;
          if (url == null) {
            tmp_3 = this.p61_1;
          } else if (!(this.n61_1.l63_1 == null) || !(this.n61_1.j63_1 == null) || !(this.n61_1.m63_1 == null) || !(this.n61_1.n63_1 == null)) {
            // Inline function 'kotlin.apply' call
            var this_1 = (new (Builder_2())()).a64(url);
            if (!(this.n61_1.l63_1 == null)) {
              this_1.u65(ensureNotNull(this.n61_1.l63_1));
            }
            if (!(this.n61_1.i63_1 == null)) {
              this_1.v65(ensureNotNull(this.n61_1.i63_1));
            }
            if (!(this.n61_1.j63_1 == null)) {
              this_1.w65(ensureNotNull(this.n61_1.j63_1));
            }
            if (!(this.n61_1.m63_1 == null)) {
              this_1.x65(this.n61_1.m63_1);
            }
            if (!(this.n61_1.n63_1 == null)) {
              this_1.y65(this.n61_1.n63_1);
            }
            tmp_3 = this_1.e3a();
          } else {
            // Inline function 'kotlin.apply' call
            var this_2 = (new (Builder_1())()).a65(url);
            if (!(this.n61_1.i63_1 == null)) {
              Companion_getInstance_0();
              // Inline function 'kotlin.time.Companion.milliseconds' call
              var this_3 = ensureNotNull(this.n61_1.i63_1);
              var tmp$ret$26 = toDuration(this_3, DurationUnit_MILLISECONDS_getInstance());
              this_2.m65(tmp$ret$26);
            }
            tmp_3 = this_2.e3a();
          }
          tmp_2 = tmp_3;
        }
        tmp_1.q61_1 = tmp_2;
        var tmp1_elvis_lhs = this.n61_1.e63_1;
        var dispatcher = tmp1_elvis_lhs == null ? get_defaultDispatcher() : tmp1_elvis_lhs;
        this.o61_1 = new (ConcurrencyInfo())(dispatcher, CoroutineScope(dispatcher));
        this.i62_1 = new (NetworkInterceptor())(this.p61_1, this.q61_1);
        var tmp_4 = this;
        tmp_4.j62_1 = lazy(() => {
          // Inline function 'kotlin.collections.buildList' call
          // Inline function 'kotlin.collections.buildListInternal' call
          // Inline function 'kotlin.apply' call
          var this_0 = ArrayList().p2();
          this_0.u2(this.n61_1.n62_1);
          if (!(this.t61_1 == null)) {
            this_0.j2(this.t61_1);
          }
          this_0.u2(this.n61_1.o62_1);
          if (!(this.u61_1 == null)) {
            this_0.j2(this.u61_1);
          }
          this_0.u2(this.n61_1.p62_1);
          var tmp0_elvis_lhs = this.w61_1;
          this_0.j2(tmp0_elvis_lhs == null ? RetryOnErrorInterceptor() : tmp0_elvis_lhs);
          this_0.u2(this.n61_1.q62_1);
          this_0.j2(this.i62_1);
          return this_0.g8();
        });
      }
      z65(query) {
        return ApolloCall().l61(this, query);
      }
      a66(mutation) {
        return ApolloCall().l61(this, mutation);
      }
      m6() {
        cancel(this.o61_1.s64_1);
        this.p61_1.n10();
        this.q61_1.n10();
      }
      k62(apolloRequest, throwing) {
        var flow = channelFlow(ApolloClient$executeAsFlowInternal$slambda(this, apolloRequest, throwing));
        return buffer(flow, 2147483647);
      }
      q64(apolloRequest, throwing) {
        var apolloClient = this;
        // Inline function 'kotlin.apply' call
        var this_0 = apolloRequest.g44();
        this_0.a43(this.o61_1.t44(this.s61_1).t44(apolloClient.z61_1).t44(this_0.j42_1));
        var tmp0_elvis_lhs = this_0.l42_1;
        this_0.d43(tmp0_elvis_lhs == null ? apolloClient.b62_1 : tmp0_elvis_lhs);
        var tmp1_elvis_lhs = this_0.o42_1;
        this_0.g43(tmp1_elvis_lhs == null ? apolloClient.d62_1 : tmp1_elvis_lhs);
        var tmp2_elvis_lhs = this_0.p42_1;
        this_0.h43(tmp2_elvis_lhs == null ? apolloClient.e62_1 : tmp2_elvis_lhs);
        var tmp3_elvis_lhs = this_0.n42_1;
        this_0.i43(tmp3_elvis_lhs == null ? apolloClient.f62_1 : tmp3_elvis_lhs);
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_1 = ArrayList().p2();
        if (!(this_0.s42_1 === true)) {
          // Inline function 'kotlin.collections.orEmpty' call
          var tmp0_elvis_lhs_0 = apolloClient.c62_1;
          var tmp$ret$6 = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
          this_1.u2(tmp$ret$6);
        }
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs_1 = this_0.m42_1;
        var tmp$ret$7 = tmp0_elvis_lhs_1 == null ? emptyList() : tmp0_elvis_lhs_1;
        this_1.u2(tmp$ret$7);
        var headers = this_1.g8();
        this_0.e43(headers);
        var tmp4_elvis_lhs = this_0.q42_1;
        var canBeBatched = tmp4_elvis_lhs == null ? apolloClient.g62_1 : tmp4_elvis_lhs;
        if (!(canBeBatched == null)) {
          this_0.f43('X-APOLLO-CAN-BE-BATCHED', canBeBatched.toString());
        }
        var tmp5_elvis_lhs = this_0.t42_1;
        var tmp;
        if (tmp5_elvis_lhs == null) {
          var tmp6_safe_receiver = apolloClient.v61_1;
          tmp = tmp6_safe_receiver == null ? null : tmp6_safe_receiver(apolloRequest);
        } else {
          tmp = tmp5_elvis_lhs;
        }
        this_0.l43(tmp);
        var tmp7_elvis_lhs = this_0.u42_1;
        this_0.m43(tmp7_elvis_lhs == null ? apolloClient.x61_1 : tmp7_elvis_lhs);
        var tmp8_elvis_lhs = this_0.r42_1;
        this_0.k43(tmp8_elvis_lhs == null ? apolloClient.h62_1 : tmp8_elvis_lhs);
        this_0.n43(apolloClient.y61_1);
        var tmp9_elvis_lhs = this_0.k42_1;
        this_0.c43(tmp9_elvis_lhs == null ? apolloClient.a62_1 : tmp9_elvis_lhs);
        var request = this_0.e3a();
        // Inline function 'kotlin.let' call
        var it = (new (DefaultInterceptorChain())(_get_allInterceptors__eyuk02(this), 0)).d66(request);
        var tmp_0;
        if (throwing) {
          tmp_0 = onEach(it, ApolloClient$apolloResponses$slambda());
        } else {
          tmp_0 = it;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'ApolloClient');
    ApolloClientClass = $;
  }
  return ApolloClientClass;
}
//region block: exports
export {
  Builder_3 as Builder3lcn00uc5gcy3,
};
//endregion

//# sourceMappingURL=ApolloClient.mjs.map
